export default __webpack_public_path__ + "static/media/คืนยอดเทิร์นเพื่อน1ทุกวัน.597596e3.png";